/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Max_RoundsInputs */



/**
* | output |
* | --- |
* | "Number of rounds" |
*
* @param {Og_Cfg_Max_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_max_rounds = /** @type {((inputs?: Og_Cfg_Max_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Max_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre de rondes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de rondas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Número de rodadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di round")
	return /** @type {LocalizedString} */ ("Number of rounds")
});